import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import {actionsBuilder} from './actions';
import VuexPersistence from 'vuex-persist';
import axios from 'axios/index';
import {cloneDeep} from 'lodash';
import createCache from 'vuex-cache';
import localForage from 'localforage';
import {Promise} from 'es6-promise';

export const defaultState = {
  auth: {
    config: {
      skipTour: false,
    },
  },
  notifications: [
    // {message: window.config.welcomeMessage, countDown: 3},
  ],
  loading: {
    runs: false,
    metadataTypes: false,
    regions: false,
    models: false,
    scenarios: false,
    workspaces: false,
    files: false,
    characteristics: false,
  },
  data: {
    units: null,
    regions: null,
    models: null,
    scenarios: null,
    metadataTypes: null,
    runs: null,
    characteristics: {parameters: {}, variables: {}, equations: {}, timeseries: {}, layers: []},
    files: [],
  },
  interaction: {
    activeDatasets: {
      // example:
      // 'dataset-key-1': true, <- selected dataset
      // 'dataset-key-2': null, <- highlighted dataset
    },
  },
  workspaces: [],
  currentWorkspace: null,
  ui: {
    workspacesFilter: {
      publishType: null,
      sortBy: ['name', 1],
      textFilter: '',
    },
    workspacesFilterExpanded: true,
    workspaceSelector: {
      recent: [],
    },
    // skipTour: false,
    useDarkTheme: false,
  },
  previews: {},
};

export function storeBuilder(http, config) {
  Vue.use(Vuex);
  return new Promise(resolve => {
    const state = cloneDeep(defaultState);
    const resolveStore = resolve;
    let store;

    const persistedState = new VuexPersistence({
      storage: localForage,
      asyncStorage: true,
      key: `ixmp-${config.env}`,
      restoreState: (key, storage) => new Promise(resolve => {
        storage.getItem(key).then(item => {
          const loadedState = (typeof item === 'string' ? JSON.parse(item) : item) || cloneDeep(defaultState);
          if (loadedState && loadedState.auth && loadedState.auth.token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${loadedState.auth.token}`;
          }
          resolve(loadedState);
          resolveStore(store);
        });
      }),
      reducer: state => {
        const removingRawData = panel => ({...panel, raw: [], activeSelection: {}});
        const workspaces = state.workspaces.map(workspace => ({...workspace, panels: workspace.panels.map(removingRawData)}));
        const loading = {runs: false, metadataTypes: false, regions: false, models: false, scenarios: false, workspaces: false, downloads: false, characteristics: false};
        const data = {units: null, regions: null, models: null, scenarios: null, metadataTypes: null, runs: null, characteristics: {parameters: {}, variables: {}, timeseries: {}}};
        return {auth: state.auth, notifications: [], loading, data, workspaces, ui: state.ui};
      },
    });

    const plugins = [persistedState.plugin, createCache({timeout: 300 * 1000})];
    const actions = actionsBuilder(http, config);
    store = new Vuex.Store({state, mutations, actions, plugins, strict: process.env.NODE_ENV !== 'production'});
  });
}
